module.exports = __webpack_public_path__ + "img/mpi.fe0b8a7a.jpg";